var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIreland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 321 321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 160.773 C 0 72.407 71.634 0.773 160 0.773 C 248.366 0.773 320 72.407 320 160.773 C 320 249.139 248.366 320.773 160 320.773 C 71.634 320.773 0 249.139 0 160.773 Z",
    fill: "rgb(240,240,240)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 320.348 160.821 C 320.348 92.027 276.928 33.379 216 10.773 L 216 310.869 C 276.928 288.262 320.348 229.615 320.348 160.821 Z",
    fill: "rgb(255,152,17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M -0 160.821 C -0 229.615 43.42 288.263 104.348 310.869 L 104.348 10.773 C 43.42 33.379 -0 92.027 -0 160.821 Z",
    fill: "rgb(109,165,68)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIreland);
export default __webpack_public_path__ + "static/media/ireland.281f856acd47489752f3909039a81a42.svg";
export { ForwardRef as ReactComponent };